import styled, { css } from 'styled-components';

import { grey } from '../../theme/colors';

interface textProps {
  variant?: string;
}

const basicStyle = {
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: '400',
  marginBottom: '8px',
};

const variantStyles = (variant = 'primary') =>
  ({
    primary: css`
      ${basicStyle}
      color: ${grey.haydenGreyShade1};
    `,
    secondary: css`
      ${basicStyle}
      font-weight: 500;
      color: ${grey.haydenGreyShade2};
    `,
    ternary: css`
      ${basicStyle}
      color: ${grey.haydenGreyShade3};
    `,
  })[variant];

export const Text = styled.p<textProps>`
  ${({ variant }) => variantStyles(variant)}
`;
